/* eslint-disable indent */
import Vue from 'vue'
import App from './App'
import router from './router'

// translations
import VueI18n from 'vue-i18n'
import messages from './translations/translations'

// Vue Axios
import axios from 'axios'
import VueAxios from 'vue-axios'

// Vue Auth
import VueAuth from '@websanova/vue-auth'
import oauth from './mixins/auth'
import api from './mixins/webservice'

// Vue Alerts
import alert from './mixins/alerts'
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'

// Vue reCAPTCHA
import { VueReCaptcha } from 'vue-recaptcha-v3'

// Breadcrubms
import Breadcrumbs from './mixins/components/Breadcrubms'

import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { required, email } from 'vee-validate/dist/rules'

extend('required', {
  ...required,
  message: 'Field required!'
})

extend('email', email)

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)

Vue.component('Breadcrumbs', Breadcrumbs)

Vue.use(VueReCaptcha, { siteKey: process.env.RECAPTCHA_KEY })

Vue.use(VueI18n)

Vue.use(VueAxios, axios)

Vue.router = router

// mark all requests as AJAX for backend
Vue.axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest'
}

Vue.use(VueAuth, {
    auth: require('./components/auth/bearerDriver'),
    http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
    router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
    parseUserData: function (data) {
        return data.user
    },
    rolesVar: 'access_type',
    loginData: { url: process.env.SERVICE_URL + process.env.AUTH_LOGIN, method: 'POST', redirect: '/voucher/search', fetchUser: true },
    refreshData: { url: process.env.SERVICE_URL + process.env.AUTH_REFRESH, enabled: false },
    fetchData: { url: process.env.SERVICE_URL + process.env.AUTH_USER, method: 'GET', enabled: true },
    logoutData: { url: process.env.SERVICE_URL + process.env.AUTH_LOGOUT, redirect: '/login', method: 'POST' }
})

Vue.use(VueSweetalert2)

Vue.mixin(oauth)
Vue.mixin(api)

Vue.mixin(alert)

Vue.config.productionTip = false

const i18n = new VueI18n({
    locale: 'en',
    fallbackLocale: 'en',
    messages
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js